












import { defineComponent, ref } from "@nuxtjs/composition-api";
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import ProductOptions from "~/components/mbooks/Configurable/ProductOptions.vue";
import { PropType } from "vue";
import type { MbookOptionType, MbookVariantOptionType } from "~/utils/types";
import { ConfigurableProduct } from "~/composables";

export default defineComponent({
  components: {
    LoadWhenVisible,
    ProductOptions,
  },
  props: {
    product:{
      type: Object as PropType<ConfigurableProduct>,
        required: true
    }
  },
  setup(props) {

    const naturaOptionAttributeUid = ref<string>('');

    const options = ref<Array<MbookOptionType>>([]); /** contains variant datas and its configurable_options value {variant:{sku, name, price_range ... , configoption.label, configoption.uid}} */
    naturaOptionAttributeUid.value = props.product.configurable_options.find(el=>el.attribute_code=='natura').attribute_uid
    
    props.product.variants.forEach(variant=>{
        options.value.push({
          product:props.product,
          variant:variant.product as unknown as MbookVariantOptionType,
          ...props.product.configurable_options[0].values.find(opt => opt.uid == variant.attributes.find(el=>el.code=='natura').uid)
        } as MbookOptionType )
         
        })


      return {
        naturaOptionAttributeUid,
        options
      }
  },
});
